// extracted by mini-css-extract-plugin
export default {"App":"MainPage_App__yd0qC","container":"MainPage_container__Lm-lH"};